export function setIdPlayer(player_id) {
    console.log(player_id);
    localStorage.setItem('player_id', player_id);
    // Set the current timestamp when setting player ID
    updateLastActiveTimestamp();
}

export function getIdPlayer() {
    // Check if player ID has expired before returning it
    if (hasPlayerIdExpired()) {
        removeIdPlayer();
        return null;
    }
    // If not expired, update last active timestamp and return ID
    updateLastActiveTimestamp();
    return localStorage.getItem('player_id');
}

export function removeIdPlayer() {
    localStorage.removeItem('player_id');
    localStorage.removeItem('last_active_timestamp');
}

// Helper function to update last active timestamp
export function updateLastActiveTimestamp() {
    const now = new Date().getTime();
    localStorage.setItem('last_active_timestamp', now);
}

// Check if the player ID has expired (24 hours of inactivity)
function hasPlayerIdExpired() {
    const lastActiveTimestamp = localStorage.getItem('last_active_timestamp');
    if (!lastActiveTimestamp) return true;
    
    const now = new Date().getTime();
    const inactivityPeriod = now - parseInt(lastActiveTimestamp);
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    
    return inactivityPeriod > oneDay;
}